import API from '../apiCreate'
import { getHeaders } from '../getHeaders'
import { getParams } from '../getParams'
import axios from 'axios'
import {
  EmptyResponse,
  PaginationParam,
  ResponseNumber,
  ResponseString,
} from '../types/base.types'
import {
  RequestChangeLicense,
  RequestRenewLicense,
  ResponseLicenseAndPayment,
  ResponsePayment,
  ResponseMetricsGraduationData,
  RequestPriceForPayment,
} from '../types/licenseAndPayment.types'

export const licenseAndPaymentApi = {
  getData: () =>
    API.get<ResponseLicenseAndPayment>('license-and-payment/get-data'),

  getMetricsGraduationData: () =>
    API.get<ResponseMetricsGraduationData>(
      'license-and-payment/get-metrics-graduation-data',
    ),

  renewLicense: (data: RequestRenewLicense) =>
    API.post<ResponsePayment>('license-and-payment/renew-license', data),

  changeLicense: (data: RequestChangeLicense) =>
    API.post<ResponsePayment>('license-and-payment/change-license', data),

  getPriceForPayment: (data: RequestPriceForPayment) =>
    API.post<ResponseNumber>('license-and-payment/get-price-for-payment', data),
}
